<template>
  <div id="app">
    <home :page-suffix="pageSuffix"></home>
    <el-dialog title="提示" class="renji" :visible.sync="showActive" :show-close="false" append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <span>根据培训要求，需要进行人机验证，请在 60s 内点击下方按钮进行交互验证！</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="confirmDialogBtn" type="primary" @click="confirm">
          <div>人机验证</div>
          <el-progress width="30" stroke-width="2" :percentage="percentage" :color="curColor" type="circle" class="progress-circle" :format="format"></el-progress>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import * as dd from "dingtalk-jsapi";
import home from "./views/Home";
export default {
  components: {
    home,
  },
  provide() {
    return {
      $app: this,
    };
  },

  data() {
    return {
      pageSuffix: "else",
      // showFace: false,
      count: 0,
      time: 60,
      showActive: false,
      timerConfirm: null,
      timerActive: null,
    };
  },
  created() {
    if (localStorage.getItem("isFace")) {
      this.$root.isFace = JSON.parse(localStorage.getItem("isFace"));
      this.$root.verifyTime = localStorage.getItem("verifyTime");
      this.$root.verifyTime2 = localStorage.getItem("verifyTime2");
      this.$root.qrCodePath = localStorage.getItem("qrCodePath");
    }
    let htmlName = window.location.pathname;
    let route = ["_project", "_product", ""];
    let pageSuffix = "else";
    for (let i = 0; i < route.length; i++) {
      if (htmlName.indexOf(`/index${route[i]}.html`) >= 0) {
        pageSuffix = "index";
        break;
      } else if (htmlName.indexOf(`/index1${route[i]}.html`) >= 0) {
        pageSuffix = "index1";
        break;
      } else if (htmlName.indexOf(`/ncIndex${route[i]}.html`) >= 0) {
        pageSuffix = "ncIndex";
        break;
      } else if (htmlName.indexOf(`/aliIndex${route[i]}.html`) >= 0) {
        pageSuffix = "aliIndex";
        break;
      } else if (htmlName.indexOf(`/xcIndex${route[i]}.html`) >= 0) {
        pageSuffix = "xcIndex";
        break;
      } else if (htmlName.indexOf(`/zxqyIndex${route[i]}.html`) >= 0) {
        pageSuffix = "zxqyIndex";
        break;
      } else if (htmlName.indexOf(`/hntxIndex${route[i]}.html`) >= 0) {
        pageSuffix = "hntxIndex";
        break;
      } else {
        pageSuffix = "else";
      }
      // window.dd = dd;
    }
    this.pageSuffix = pageSuffix;
    // 活跃度检测
    document.body.addEventListener("mousedown", () => {
      localStorage.setItem("activeTimeBefore", new Date().getTime());
    });
    document.body.addEventListener("keydown", () => {
      localStorage.setItem("activeTimeBefore", new Date().getTime());
    });
    dsf.config["setting_nc_living_textinput"] = Number(dsf.config["setting_nc_living_textinput"]) || null;
    if (dsf.config["setting_nc_living_liveness"] == 1 && dsf.config["setting_nc_living_textinput"] != "") {
      console.log("倒计时执行了");
      this.timeOut();
    }
    // this.faceTimeOut();
  },
  mounted() {
    if (window.location != parent.location) {
      return;
    }
    // window.addEventListener("storage", () => {
    //   this.$root.isFace = JSON.parse(localStorage.getItem("isFace"));
    //   // 人脸识别
    //   // if (JSON.parse(localStorage.getItem("isFace"))) {
    //   //   this.faceInteval();
    //   // }
    //   // 人机验证
    //   this.$root.dialogVisible = JSON.parse(localStorage.getItem("close"));
    //   this.$root.time = localStorage.getItem("livingtime");
    //   if (this.$root.dialogVisible) {
    //     this.$root.livingBody();
    //     window.clearTimeout(this.$root.timer2);
    //   } else {
    //     window.clearTimeout(this.$root.timer);
    //   }
    //   this.$root.resetTimer = localStorage.getItem("resetTimer");
    //   if (this.$root.resetTimer == "true") {
    //     this.$root.timeOut();
    //   }
    // });
  },
  methods: {
    livingBody() {
      if (dsf.config["setting_nc_living_textinput"]) {
        localStorage.setItem("close", JSON.stringify(true));
        var timerFun = () => {
          var nowDate = new Date();
          this.time = 60 - Math.floor((nowDate - beforeDate) / 1000);
          this.percentage = this.time * (100 / 60);
          this.$forceUpdate();
          if (localStorage.getItem("close") == "true") {
            if (this.time <= 0) {
              if (this.timerConfirm) clearTimeout(this.timerConfirm);
              this.showActive = false;
              this.clearCookie();
              location.reload();
            } else {
              this.timerConfirm = setTimeout(timerFun, 1000);
            }
          } else {
            this.showActive = false;
            clearTimeout(this.timerConfirm);
            this.timeOut();
          }
        };
        clearTimeout(this.timerConfirm);
        this.timerConfirm = null;
        this.time = 60;
        this.timerConfirm = setTimeout(timerFun, 1000);
        var beforeDate = new Date();
      }
    },
    timeOut() {
      if (window.location != parent.location && !dsf.getCookie("iad")) {
        return;
      }
      let time = JSON.parse(JSON.stringify(Number(dsf.config["setting_nc_living_textinput"])));
      if (this.timerActive) {
        clearTimeout(this.timerActive);
        this.timerActive = null;
      }
      let timeFun = () => {
        if (!this.showActive) {
          var nowDate = new Date();
          var beforeDate = localStorage.getItem("activeTimeBefore");
          if (time - Math.floor((nowDate - beforeDate) / 60000) <= 0) {
            clearTimeout(this.timerActive);
            this.timerActive = null;
            time = JSON.parse(JSON.stringify(Number(dsf.config["setting_nc_living_textinput"])));
            if (dsf.config["setting_nc_living_liveness"] == 1 && dsf.getCookie("userId")) {
              this.showActive = true;
              this.livingBody();
              // console.log(this.livingBody);
            }
          } else {
            this.timerActive = setTimeout(timeFun, 1000);
          }
        }
      };
      this.timerActive = setTimeout(timeFun, 1000);
      localStorage.setItem("activeTimeBefore", new Date().getTime());
    },
    confirm() {
      localStorage.setItem("close", JSON.stringify(false));
      this.showActive = !this.showActive;
      // this.show = JSON.parse(localStorage.getItem("close"));
      if (dsf.config["setting_nc_living_liveness"] == 1 && dsf.config["setting_nc_living_textinput"] != "") {
        clearTimeout(this.timerConfirm);
        this.timeOut();
      }
    },
    format(list, index) {
      return this.time + "s";
    },
    clearCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; ) {
          document.cookie = keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下的,例如：m.kevis.com
          document.cookie = keys[i] + "=0;path=/;domain=" + document.domain + ";expires=" + new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
          document.cookie = keys[i] + "=0;path=/;domain=kevis.com;expires=" + new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
        }
      }
      console.log("已清除");
    },
  },
  computed: {
    curColor() {
      return this.$root.currentTheme?.normal || "#fc7001";
    },
    showFace1() {
      return this.$root.isFace;
    },
  },
};
</script>
